import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  [
    'WebformElementItem',
    'WebformElementProcessedText',
    'WebformElementWebformMarkup',
  ],
  (item) => {
    if (!item.element.markup) {
      return null
    }
    return {
      $el: 'div',
      attrs: {
        class: 'markup ck-content !text-base',
        innerHTML: item.element.markup,
      },
    }
  },
)
